module.exports = __webpack_public_path__ + "img/scopus.6716550c.png";